import { getSourceTypeIcon } from '@/types/sourceTypeRegistry';

interface SourceTypeIconProps {
    configType?: string | null;
    className?: string;
}

const SourceTypeIcon = ({
    configType,
    className = 'size-3.5'
}: SourceTypeIconProps) => {
    const Icon = getSourceTypeIcon(configType);
    return <Icon className={className} />;
};

export default SourceTypeIcon;
